<template>
  <div class="FooterMenu">
    <a v-for="{ text, url, id } in entries"
      :id="id && id"
      :key="text"
      :href="url"
      class="link"
    >
      {{ text }}
    </a>
  </div>
</template>

<script>
export default {
  props: {
    entries: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped>
.link {
  display: block;
  padding: var(--spacing-1) 0;
}
.link:hover {
  text-decoration: underline;
}
</style>
